import { useState } from "react";
import { Download, Receipt as ReceiptIcon } from "lucide-react";
import { useTranslation } from "react-i18next";
import api from "@/lib/api";
import { toast } from "sonner";
import { money } from "@/lib/format";

export function CustomerReceipts({ bookings }) {
  const { t } = useTranslation();
  const [busy, setBusy] = useState(null);
  const paid = (bookings || []).filter((b) => b.payment_status === "paid");

  const download = async (b) => {
    setBusy(b.id);
    try {
      const r = await api.get(`/my/bookings/${b.id}/receipt`, { responseType: "blob" });
      const url = URL.createObjectURL(new Blob([r.data], { type: "application/pdf" }));
      const a = document.createElement("a");
      a.href = url;
      a.download = `belo-receipt-${b.id.slice(0, 8)}.pdf`;
      document.body.appendChild(a);
      a.click();
      a.remove();
      URL.revokeObjectURL(url);
    } catch {
      toast.error(t("receipts.downloadError"));
    } finally {
      setBusy(null);
    }
  };

  if (paid.length === 0) {
    return (
      <div className="bg-white rounded-2xl border border-slate-200 p-10 text-center" data-testid="receipts-empty">
        <span className="grid place-items-center w-14 h-14 rounded-full bg-slate-50 text-slate-400 mx-auto"><ReceiptIcon size={26} /></span>
        <p className="text-slate-500 mt-4 font-medium">{t("receipts.empty")}</p>
        <p className="text-slate-400 text-sm mt-1">{t("receipts.emptySub")}</p>
      </div>
    );
  }

  return (
    <div className="bg-white rounded-2xl border border-slate-200 overflow-x-auto">
      <table className="w-full text-left text-sm" data-testid="receipts-table">
        <thead className="bg-slate-50 text-slate-500 text-xs uppercase tracking-wide">
          <tr>
            <th className="px-5 py-3 font-semibold">{t("receipts.vehicle")}</th>
            <th className="px-5 py-3 font-semibold">{t("receipts.dates")}</th>
            <th className="px-5 py-3 font-semibold text-right">{t("receipts.total")}</th>
            <th className="px-5 py-3 font-semibold text-right">{t("receipts.receipt")}</th>
          </tr>
        </thead>
        <tbody>
          {paid.map((b) => (
            <tr key={b.id} data-testid={`receipt-row-${b.id}`} className="border-t border-slate-100 hover:bg-slate-50 transition-colors">
              <td className="px-5 py-3 font-medium text-slate-900">{b.car_name}</td>
              <td className="px-5 py-3 text-slate-500 whitespace-nowrap">{b.pickup_date} → {b.return_date}</td>
              <td className="px-5 py-3 text-right font-semibold">{money(b.amount_due)}</td>
              <td className="px-5 py-3 text-right">
                <button onClick={() => download(b)} disabled={busy === b.id} data-testid={`download-receipt-button-${b.id}`} className="inline-flex items-center gap-1.5 text-blue-600 hover:text-blue-700 font-semibold disabled:opacity-50">
                  <Download size={15} /> PDF
                </button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
